// extracted by mini-css-extract-plugin
module.exports = {"title":"error-page_title___0S3Z"};